module.exports = __webpack_public_path__ + "kr.svg?e590ec7a308ec34ecebaa872333e48a5";